module.exports = __webpack_public_path__ + "media/src/images/mails/f59b00-58707ea8f8e833b6e5513d4a1c612753.png";